import { Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { EquipmentRotationsComponent } from './equipment-rotations/equipment-rotations.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { HistoryComponent } from './history/history.component';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { ServicePageService } from './service.service';
@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
})
export class ServiceComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  active: number;
  sub = new Subscription();
  hasFullPermission = false;
  activatedRouteUrl: string;
  showError = false;
  currentFacility: FacilityObject;
  equipmentRotationCount = 0;
  maintenanceCount = 0;
  showEquipmentSelection = true;
  isReloadEquipmentList = true;

  isServiceNoticeAvailable = false;
  selectedEquipmentActivityId = "-1";

  hintMsgFullContent="";
  hintMsg="";
  serviceNoticesHint = false;
  showErrorCodes = false;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private _loader: HaloLoaderService,
    private _servicePageService: ServicePageService
  ) {
    const routeChangeSub = this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url) {
          this.activatedRouteUrl = event.url;
          if("/service" === this.activatedRouteUrl) this.active = 1;
        }
      }
    });

    this.sub.add(routeChangeSub);
    this.hintMsgFullContent = this.commonUtil.translateText('TRACK.STATUS.SERVICE.REQUEST.TOOLTIP');
  }

  ngOnInit(): void {
    this.currentFacility = this._facilityService.selectedFacility();
    this.updateServiceTabAvailability();
    this._setDefaultTab();
    this._trackingChangingRoutes();
    const getRootScopeSub = this.rootScopeService.getRootScope().subscribe((val) => {
      this.rootScopeData = val;
    });
    this.sub.add(getRootScopeSub);  
    const facilityChanges = this._facilityService.selectedFacilitySource.subscribe((val) => {
      this.equipmentRotationCount = 0;
      this.maintenanceCount = 0;
      
      this.currentFacility = val;
      this.showErrorCodes = this.currentFacility.summary.isPlanetFitness === "true";
      if(this.showErrorCodes){
        this.hintMsg = this.hintMsgFullContent;
      }else{
        this.hintMsg = this.hintMsgFullContent.split(".")[0]+".";
      }
      const hasViewPermission = this.currentFacility.summary.userRights.serviceNotice !== "H";
      if(hasViewPermission){
        this.getServiceCounts();
        this.isReloadEquipmentList = !this.isReloadEquipmentList;
        this.selectedEquipmentActivityId = "-1";
        if(this.currentFacility.consoleEquipments){
          this.updateServiceTabAvailability();
          this._setDefaultTab();
        }else{
          this.commonUtil.redirectToAvailablePage();
        } 
      }else{
        this.commonUtil.redirectToAvailablePage();
      }
    });
    this.sub.add(facilityChanges);
    const servicePageServiceSub = this._servicePageService.serviceEquipmentInfoSubscriber.subscribe((val) => {
      if(val) {
        this.equipmentRotationCount = val.rotationsCount || 0;
        this.maintenanceCount = val.maintenanceItems?.totalCount || 0;
      }
    });
    this.sub.add(servicePageServiceSub);

    const popupData = this._facilityService.getAnnouncements();
    this.serviceNoticesHint = popupData.showServiceRequestsTrackStatusTooltip;
    this.showErrorCodes = this.currentFacility.summary.isPlanetFitness === "true";
    if(this.showErrorCodes){
      this.hintMsg = this.hintMsgFullContent;
    }else{
      this.hintMsg = this.hintMsgFullContent.split(".")[0]+".";
    }
  }

  updateServiceTabAvailability(){
    this.isServiceNoticeAvailable = this.currentFacility.summary.userRights.isAdmin === 'true' || this.currentFacility.summary.userRights.serviceNotice !== 'H';
  }

  private getServiceCounts() {
    if (this.currentFacility) this._servicePageService.getCounts(this.currentFacility);
  }

  private _setDefaultTab(): void {
    if (this._router.routerState.snapshot.url.includes('equipmentRotations')) {
      this.active = 1;
      this.navigateToChild('equipmentRotations');
    } else if (this._router.routerState.snapshot.url.includes('maintenance')) {
      this.active = 2;
      this.navigateToChild('maintenance');
    } else if (this._router.routerState.snapshot.url.includes('history')) {
      this.active = 3;
      this.navigateToChild('history');
    }
  }

  private _trackingChangingRoutes(): void {
    const routes = this._router.events.subscribe((val: any) => {
      if (val.url?.includes('equipmentRotations')) {
        this.active = 1;
      }
      if (val.url?.includes('maintenance')) {
        this.active = 2;
      }
      if (val.url?.includes('history')) {
        this.active = 3;
      }
    });
    this.sub.add(routes);
  }

  navigateToChild(childPath: string): void {
    if(this.rootScopeData && this.rootScopeData.isPageHasUnsavedChanges && !this._router.routerState.snapshot.url.includes(childPath)) {
      this.rootScopeData.pathToNavigate = childPath;
      this.rootScopeData.showUnSavedChangesModal = true;
      setTimeout(() => {
        this._setDefaultTab();
      });
    } else {
      this._router.navigate([childPath], { relativeTo: this._activatedRoute }).then(val =>{
        this.getServiceCounts();
      });
    }
  }

  private onComponentActivated(componentRef: any) {
    if(componentRef instanceof MaintenanceComponent) {
      this.showEquipmentSelection = false;
      this.selectedEquipmentActivityId = "-1";
    } else {
      this.showEquipmentSelection = true;
    }

    if (componentRef instanceof EquipmentRotationsComponent || componentRef instanceof MaintenanceComponent || componentRef instanceof HistoryComponent) {
      this.activatedComponentRef = componentRef;
      this.activatedComponentRef.onSelectionChange(this.selectedEquipmentActivityId);
    }
  }

  private onEquipmentChange(activityId: string) {
    this.selectedEquipmentActivityId = activityId;
    if(this.activatedComponentRef){
      this.activatedComponentRef.onSelectionChange(this.selectedEquipmentActivityId);
    }    
  }

  onCloseHint(){
    this._facilityService.setAnnouncementsState('showServiceRequestsTrackStatusTooltip', false);      
    this.serviceNoticesHint = false; 
  }

  onDismiss() {
    //...
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this._loader.endProcess();
  }
}
